// Change this one line to switch between Live and Local URLs
export const BASE_URL = "https://meetingfix.com/admin-master";
// export const BASE_URL = "http://localhost/admin-master";
